import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { bandInfo, navLinks } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'glass-dark py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#home');
            }}
            className="flex-shrink-0 group"
          >
            <img
              src={bandInfo.logo}
              alt={bandInfo.name}
              className="h-12 lg:h-14 w-auto transition-all duration-500 group-hover:scale-105"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className="relative text-white/70 hover:text-gold-400 transition-colors duration-300 text-sm font-medium tracking-widest uppercase after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-[1px] after:bg-gold-400 after:transition-all after:duration-300 hover:after:w-full"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center">
            <a href={`tel:${bandInfo.phone.replace(/\s/g, '')}`}>
              <button className="btn-gold px-6 py-3 rounded-none flex items-center gap-2 text-sm tracking-wider uppercase">
                <Phone className="w-4 h-4" />
                Pozovite
              </button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gold-400 p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden fixed inset-0 top-0 bg-black/98 backdrop-blur-xl transition-all duration-500 ${
          isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-6">
            <img src={bandInfo.logo} alt={bandInfo.name} className="h-12" />
            <button onClick={() => setIsMenuOpen(false)} className="text-gold-400">
              <X className="w-6 h-6" />
            </button>
          </div>
          
          <nav className="flex flex-col items-center justify-center flex-1 space-y-8">
            {navLinks.map((link, index) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className="text-2xl font-light tracking-widest uppercase text-white/80 hover:text-gold-400 transition-colors duration-300"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {link.name}
              </a>
            ))}
            <div className="pt-8">
              <a href={`tel:${bandInfo.phone.replace(/\s/g, '')}`}>
                <button className="btn-gold px-8 py-4 rounded-none flex items-center gap-3 text-sm tracking-wider uppercase">
                  <Phone className="w-4 h-4" />
                  {bandInfo.phone}
                </button>
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
